import { AccountMovementsViewModel } from "../../../accounting/models/accounting-movement.model";

export class PartnersModel {
    uid: number;
    nameOrBusinessName: string;
    vatNumber: string;
    participation: number;
    participationAmount: number;
    accountingModels118: string;
    accountingModels551: string;
    //Importación cuentas contables
    manualMovement: AccountMovementsViewModel;
    partnersTypesId: number;
    partnersPositionId: number;
    remunerated: boolean;
}

export class TransactionModel {
    uid: number;
    partnerId: number;
    date: Date;
    amount: number;
    bankAccountsUid: string;
    description: string;
    typePay: string;
    commissions: number;
    bankAccountInfo: string;
    transactionType: boolean;
    efectivoId: string;
    accountingModelsId: boolean;

    constructor() {
        this.commissions = 0;
    }
}

export class PartnersTypes {
  public id: number;
  public description: string;
}

export class PartnersPosition {
  public id: number;
  public description: string;
}

export class PartnersExtras {
  public partnersTypes: PartnersTypes[];
  public partnersPosition: PartnersPosition[];
}
